export default __webpack_public_path__ + "static/media/Dr.Mariana_Seabra.22cf2c88.png";